export default "__VITE_ASSET__Bbd654A0__"